module.exports = __webpack_public_path__ + "static/img/zhishifuweng.86fb608.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/zhishifuweng.svg
// module id = 1Biz
// module chunks = 1